import { render, staticRenderFns } from "./pcfallimg.vue?vue&type=template&id=184ab169&scoped=true"
import script from "./pcfallimg.vue?vue&type=script&lang=js"
export * from "./pcfallimg.vue?vue&type=script&lang=js"
import style0 from "./pcfallimg.vue?vue&type=style&index=0&id=184ab169&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184ab169",
  null
  
)

export default component.exports